import { Component, Input, OnInit } from '@angular/core';
import { Entry } from 'contentful';

@Component({
  selector: 'app-test-result-profile',
  templateUrl: './test-result-profile.component.html',
  styleUrls: ['./test-result-profile.component.scss']
})
export class TestResultProfileComponent implements OnInit {
  @Input() public testResult: any;
  @Input() public sharedTestResult: boolean;
  @Input() public content: Entry<any>;

  constructor() {}

  ngOnInit() {}
}
